import {defineMessages} from 'react-intl'

export const collectionsMessages = defineMessages({
  newCollection: {
    id: 'Collections.newCollection',
    defaultMessage: 'New Collection'
  },
  editCollection: {
    id: 'CollectionListing.editCollection',
    defaultMessage: 'Edit Collection'
  },
  importRoutesAndRides: {
    id: 'CollectionListing.importRoutesAndRides',
    defaultMessage: 'Import Routes & Rides'
  },
  showMore: {
    id: 'CollectionListing.showMore',
    defaultMessage: 'Show More'
  },
  hideMore: {
    id: 'CollectionListing.hideMore',
    defaultMessage: 'Hide More'
  },
  addToCollection: {
    id: 'CollectionItems.addToCollection',
    defaultMessage: 'Add to Collection'
  },
  removeFromCollection: {
    id: 'CollectionItems.removeFromCollection',
    defaultMessage: 'Remove from collection'
  },
  noTitleError: {
    id: 'CollectionError.noTitle',
    defaultMessage: 'Please enter a title for your collection'
  },
  tooLongError: {
    id: 'CollectionError.tooLong',
    defaultMessage: 'This title is too long-- please pick a title less than 80 characters'
  }
})
